var _rect, _path, _path2, _path3, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriblLogoWhiteAug23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 71,
    viewBox: "0 0 133 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 69,
    transform: "matrix(1 0 0 -1 121.796 69.931)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7908 46.885C36.7908 40.2548 42.1657 34.8799 48.796 34.8799V23.8391C36.0681 23.8391 25.75 34.1571 25.75 46.885C25.75 46.8851 25.75 46.8851 25.75 46.8851V69.931H36.7963V46.885H36.7908Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2448 23.977C11.2448 17.3467 16.6197 11.9718 23.25 11.9718V0.93103C10.5221 0.93103 0.20401 11.2491 0.20401 23.977H11.2448ZM23.25 34.8799C16.6197 34.8799 11.2448 40.2548 11.2448 46.885H11.2503V69.931H0.20401V46.8851V46.885C0.204057 34.1571 10.5221 23.8391 23.25 23.8391V34.8799Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7962 46.931H70.796V0.93103H81.796V27.372C85.3012 25.2188 89.4266 23.9771 93.8419 23.9771C106.57 23.9771 116.888 34.2951 116.888 47.023C116.888 59.7509 106.57 70.069 93.8419 70.069C81.114 70.069 70.796 59.7509 70.796 47.023C70.796 46.9923 70.796 46.9617 70.7962 46.931ZM81.8321 47.023C81.8321 40.3901 87.2091 35.0131 93.8419 35.0131C100.475 35.0131 105.852 40.3901 105.852 47.023C105.852 53.6559 100.475 59.0329 93.8419 59.0329C87.2091 59.0329 81.8321 53.6559 81.8321 47.023Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88.2611,
    y: 41.4999,
    width: 11.1618,
    height: 11.1618,
    rx: 5.58088,
    fill: "#5CC48E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 46,
    transform: "matrix(1 0 0 -1 54.296 69.931)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriblLogoWhiteAug23);
export default __webpack_public_path__ + "static/media/fribl-LOGO-white-aug23.689498d16dd8dcffcfc149d57d4c5c14.svg";
export { ForwardRef as ReactComponent };